import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_NEXT_NUMBERING } from "../Schema/WorkGroup";

export const useGetNextNumberingOfWorkGroup = () => {
  // const { refetch } = useQuery(GET_NEXT_NUMBERING, {
  //   onCompleted: ({ getNextNumberingWorkGroup }) => {
  //     console.log(getNextNumberingWorkGroup, "getNextNumberingWorkGroup");
  //     if (dialogTitle === "Create")
  //       setFieldValue("numbering", getNextNumberingWorkGroup);
  //   },
  // });
  // useEffect(() => {
  //   refetch();
  // }, []);

    const { refetch, data } = useQuery(GET_NEXT_NUMBERING);
    useEffect(() => {
      refetch();
    }, []);
    return { numbering: data?.getNextNumberingWorkGroup, refetch };

  // return { numbering, refetch };
};
